var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTredcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 539.115,
    y1: 540.885,
    x2: -39.114,
    y2: 1119.114,
    gradientTransform: "translate(86.999 2043.959) scale(1.812 -1.812)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f79f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4f79f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#4f79f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#4f79f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#4f7af6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#4f7af6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#4f7bf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#4e7cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#4e7df6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#4e7df6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#4e7ef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#4d7ff6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#4d80f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#4d81f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4d81f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#4d82f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#4c83f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#4c84f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#4c85f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#4c85f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#4c86f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#4b87f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#4b88f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4b88f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4b89f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#4b8af7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#4b8af7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#4a8bf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#4a8cf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#4a8cf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#4a8df7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#4a8ef7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#498ff7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#498ff7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#4990f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#4991f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#4992f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#4893f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#4893f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#4894f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#4895f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#4896f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#4797f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#4797f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#4798f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#4799f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#469af8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#469af8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#469bf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#469bf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#469bf8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 540.002,
    y1: 854.302,
    x2: 540.002,
    y2: 345.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f94f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#4c8ff6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4483f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#366ef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b5df6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f94f7"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m1238.367,539.867c-.837,8.535-1.891,17.04-3.15,25.52-1.253,8.481-2.722,16.925-4.391,25.334-1.674,8.408-3.554,16.775-5.638,25.087-2.084,8.318-4.367,16.582-6.854,24.786-2.494,8.204-5.18,16.341-8.065,24.412-2.891,8.071-5.975,16.07-9.258,23.99s-6.752,15.757-10.42,23.509c-3.662,7.752-7.517,15.407-11.559,22.966-4.042,7.559-8.27,15.022-12.673,22.37-4.409,7.354-8.993,14.6-13.757,21.726-4.764,7.131-9.697,14.136-14.805,21.021-5.108,6.891-10.384,13.649-15.823,20.274s-11.035,13.119-16.793,19.467c-5.758,6.354-11.667,12.564-17.732,18.624-6.059,6.065-12.269,11.974-18.624,17.732-6.349,5.758-12.842,11.354-19.467,16.793s-13.384,10.715-20.274,15.823c-6.885,5.108-13.89,10.041-21.021,14.805-7.125,4.764-14.371,9.348-21.726,13.757-7.348,4.403-14.811,8.631-22.37,12.673-7.559,4.042-15.215,7.896-22.966,11.559-7.752,3.668-15.588,7.138-23.509,10.42s-15.919,6.367-23.99,9.258c-8.071,2.885-16.208,5.571-24.412,8.065-8.204,2.488-16.467,4.77-24.786,6.854-8.312,2.084-16.678,3.963-25.087,5.638-8.408,1.668-16.853,3.138-25.334,4.391-8.481,1.259-16.985,2.313-25.52,3.15-8.535.843-17.082,1.47-25.641,1.891-8.565.422-17.136.632-25.707.632h523.876V488.519c0,8.571-.211,17.142-.632,25.707-.422,8.559-1.048,17.106-1.891,25.641Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.664,437.171c.837-8.535,1.885-17.04,3.144-25.52,1.259-8.481,2.722-16.925,4.397-25.334,1.674-8.408,3.554-16.775,5.632-25.093,2.084-8.312,4.373-16.576,6.86-24.78,2.488-8.204,5.18-16.341,8.065-24.412,2.891-8.077,5.975-16.07,9.258-23.99,3.277-7.921,6.752-15.757,10.42-23.509,3.662-7.752,7.517-15.407,11.559-22.967,4.042-7.565,8.264-15.022,12.673-22.376,4.409-7.354,8.993-14.594,13.757-21.72,4.764-7.132,9.697-14.137,14.805-21.027,5.108-6.885,10.384-13.643,15.823-20.268s11.035-13.119,16.793-19.473c5.758-6.349,11.667-12.558,17.732-18.618,6.059-6.065,12.269-11.974,18.618-17.732,6.354-5.758,12.848-11.354,19.473-16.793,6.625-5.439,13.384-10.715,20.268-15.823,6.891-5.108,13.896-10.041,21.027-14.805,7.125-4.764,14.365-9.348,21.72-13.757,7.354-4.409,14.811-8.631,22.376-12.673,7.559-4.042,15.215-7.896,22.966-11.559,7.752-3.668,15.588-7.144,23.509-10.42,7.921-3.283,15.913-6.366,23.99-9.258,8.071-2.885,16.208-5.578,24.412-8.065,8.204-2.488,16.467-4.776,24.779-6.86,8.318-2.078,16.684-3.957,25.093-5.632,8.408-1.674,16.853-3.138,25.334-4.397,8.481-1.259,16.986-2.307,25.52-3.144,8.529-.843,17.076-1.476,25.641-1.891,8.565-.422,17.13-.632,25.707-.632H193.14V488.519c0-8.577.211-17.142.632-25.707.416-8.565,1.048-17.112,1.891-25.641Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m665.668,1009.871c-8.535-.837-17.04-1.891-25.52-3.15-8.481-1.253-16.925-2.723-25.334-4.391-8.408-1.674-16.775-3.554-25.093-5.638-8.312-2.084-16.576-4.367-24.779-6.854-8.204-2.494-16.341-5.18-24.412-8.065-8.077-2.891-16.07-5.975-23.99-9.258s-15.757-6.752-23.509-10.42c-7.752-3.662-15.407-7.517-22.966-11.559-7.565-4.042-15.022-8.27-22.376-12.673-7.354-4.409-14.594-8.993-21.72-13.757-7.131-4.764-14.136-9.697-21.027-14.805-6.885-5.108-13.643-10.384-20.268-15.823-6.626-5.439-13.119-11.035-19.473-16.793-6.349-5.758-12.558-11.667-18.618-17.732-6.065-6.059-11.974-12.269-17.732-18.624-5.758-6.348-11.354-12.841-16.793-19.467s-10.715-13.384-15.823-20.274c-5.108-6.885-10.041-13.89-14.805-21.021-4.764-7.125-9.348-14.371-13.757-21.726-4.409-7.348-8.631-14.811-12.673-22.37-4.042-7.559-7.896-15.215-11.559-22.966-3.668-7.752-7.144-15.588-10.42-23.509-3.283-7.921-6.367-15.919-9.258-23.99-2.885-8.071-5.578-16.208-8.065-24.412-2.488-8.204-4.776-16.467-6.86-24.786-2.078-8.312-3.957-16.678-5.632-25.087-1.674-8.408-3.138-16.853-4.397-25.334-1.259-8.481-2.307-16.985-3.144-25.52-.843-8.535-1.476-17.082-1.891-25.641-.422-8.565-.632-17.136-.632-25.707v523.875h523.875c-8.577,0-17.142-.211-25.707-.632-8.565-.422-17.112-1.048-25.641-1.891Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m717.016-35.356c8.571,0,17.142.211,25.707.632,8.559.416,17.106,1.048,25.641,1.891,8.535.837,17.04,1.885,25.52,3.144,8.481,1.259,16.925,2.723,25.334,4.397,8.408,1.675,16.775,3.554,25.087,5.632,8.318,2.084,16.582,4.373,24.786,6.86,8.204,2.488,16.341,5.18,24.412,8.065,8.071,2.891,16.07,5.975,23.99,9.258,7.921,3.277,15.757,6.752,23.509,10.42,7.752,3.662,15.407,7.517,22.966,11.559,7.559,4.042,15.022,8.264,22.37,12.673,7.354,4.409,14.6,8.993,21.726,13.757,7.131,4.764,14.136,9.697,21.021,14.805,6.891,5.108,13.649,10.384,20.274,15.823,6.625,5.439,13.119,11.035,19.467,16.793,6.354,5.758,12.564,11.667,18.624,17.732,6.065,6.059,11.974,12.269,17.732,18.618,5.758,6.354,11.354,12.847,16.793,19.473s10.715,13.384,15.823,20.268c5.108,6.891,10.041,13.896,14.805,21.027,4.764,7.125,9.348,14.365,13.757,21.72,4.403,7.354,8.631,14.811,12.673,22.376,4.042,7.559,7.896,15.215,11.559,22.967,3.668,7.752,7.137,15.588,10.42,23.509s6.366,15.913,9.258,23.99c2.885,8.071,5.571,16.208,8.065,24.412,2.488,8.204,4.77,16.468,6.854,24.78,2.084,8.318,3.963,16.684,5.638,25.093,1.668,8.408,3.138,16.853,4.391,25.334,1.259,8.481,2.313,16.985,3.15,25.52.843,8.529,1.47,17.076,1.891,25.641.422,8.565.632,17.13.632,25.707V-35.356h-523.876Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1061.352,488.652c-.837-8.535-1.891-17.04-3.15-25.52-1.253-8.481-2.722-16.925-4.391-25.334-1.674-8.408-3.554-16.775-5.638-25.093-2.084-8.312-4.367-16.576-6.854-24.78-2.494-8.204-5.18-16.341-8.065-24.412-2.891-8.077-5.975-16.07-9.258-23.99s-6.752-15.757-10.42-23.509c-3.662-7.752-7.517-15.407-11.559-22.967-4.042-7.565-8.27-15.022-12.673-22.376-4.409-7.354-8.993-14.594-13.757-21.72-4.764-7.132-9.697-14.137-14.805-21.027-5.108-6.885-10.384-13.643-15.823-20.268s-11.035-13.119-16.793-19.473c-5.758-6.349-11.667-12.558-17.732-18.618-6.059-6.065-12.269-11.974-18.624-17.732-6.349-5.758-12.842-11.354-19.467-16.793s-13.384-10.715-20.274-15.823c-6.885-5.108-13.89-10.041-21.021-14.805-7.125-4.764-14.371-9.348-21.726-13.757-7.348-4.409-14.811-8.631-22.37-12.673-7.559-4.042-15.215-7.896-22.966-11.559-7.752-3.668-15.588-7.144-23.509-10.42-7.921-3.283-15.919-6.366-23.99-9.258-8.071-2.885-16.208-5.578-24.412-8.065-8.204-2.488-16.467-4.776-24.786-6.86-8.312-2.078-16.678-3.957-25.087-5.632-8.408-1.674-16.853-3.138-25.334-4.397-8.481-1.259-16.985-2.307-25.52-3.144-8.535-.843-17.082-1.476-25.641-1.891-8.565-.422-17.136-.632-25.707-.632s-17.142.211-25.707.632c-8.565.416-17.112,1.048-25.641,1.891-8.535.837-17.04,1.885-25.52,3.144-8.481,1.259-16.925,2.723-25.334,4.397-8.408,1.675-16.775,3.554-25.093,5.632-8.312,2.084-16.576,4.373-24.779,6.86-8.204,2.488-16.341,5.18-24.412,8.065-8.077,2.891-16.07,5.975-23.99,9.258-7.921,3.277-15.757,6.752-23.509,10.42-7.752,3.662-15.407,7.517-22.966,11.559-7.565,4.042-15.022,8.264-22.376,12.673s-14.594,8.993-21.72,13.757c-7.131,4.764-14.136,9.697-21.027,14.805-6.885,5.108-13.643,10.384-20.268,15.823-6.626,5.439-13.119,11.035-19.473,16.793-6.349,5.758-12.558,11.667-18.618,17.732-6.065,6.059-11.974,12.269-17.732,18.618-5.758,6.354-11.354,12.847-16.793,19.473s-10.715,13.384-15.823,20.268c-5.108,6.891-10.041,13.896-14.805,21.027-4.764,7.125-9.348,14.365-13.757,21.72-4.409,7.354-8.631,14.811-12.673,22.376-4.042,7.559-7.896,15.215-11.559,22.967-3.668,7.752-7.144,15.588-10.42,23.509-3.283,7.921-6.367,15.913-9.258,23.99-2.885,8.071-5.578,16.208-8.065,24.412-2.488,8.204-4.776,16.468-6.86,24.78-2.078,8.318-3.957,16.684-5.632,25.093-1.674,8.408-3.138,16.853-4.397,25.334-1.259,8.481-2.307,16.985-3.144,25.52-.843,8.529-1.476,17.076-1.891,25.641-.422,8.565-.632,17.13-.632,25.707s.211,17.142.632,25.707c.416,8.559,1.048,17.106,1.891,25.641.837,8.535,1.885,17.04,3.144,25.52,1.259,8.481,2.722,16.925,4.397,25.334,1.674,8.408,3.554,16.775,5.632,25.087,2.084,8.318,4.373,16.582,6.86,24.786,2.488,8.204,5.18,16.341,8.065,24.412,2.891,8.071,5.975,16.07,9.258,23.99,3.277,7.921,6.752,15.757,10.42,23.509,3.662,7.752,7.517,15.407,11.559,22.966,4.042,7.559,8.264,15.022,12.673,22.37,4.409,7.354,8.993,14.6,13.757,21.726,4.764,7.131,9.697,14.136,14.805,21.021,5.108,6.891,10.384,13.649,15.823,20.274s11.035,13.119,16.793,19.467c5.758,6.354,11.667,12.564,17.732,18.624,6.059,6.065,12.269,11.974,18.618,17.732,6.354,5.758,12.848,11.354,19.473,16.793,6.625,5.439,13.384,10.715,20.268,15.823,6.891,5.108,13.896,10.041,21.027,14.805,7.125,4.764,14.365,9.348,21.72,13.757,7.354,4.403,14.811,8.631,22.376,12.673,7.559,4.042,15.215,7.896,22.966,11.559,7.752,3.668,15.588,7.138,23.509,10.42s15.913,6.367,23.99,9.258c8.071,2.885,16.208,5.571,24.412,8.065,8.204,2.488,16.467,4.77,24.779,6.854,8.318,2.084,16.684,3.963,25.093,5.638,8.408,1.668,16.853,3.138,25.334,4.391,8.481,1.259,16.986,2.313,25.52,3.15,8.529.843,17.076,1.47,25.641,1.891,8.565.422,17.13.632,25.707.632s17.142-.211,25.707-.632c8.559-.422,17.106-1.048,25.641-1.891,8.535-.837,17.04-1.891,25.52-3.15,8.481-1.253,16.925-2.723,25.334-4.391,8.408-1.674,16.775-3.554,25.087-5.638,8.318-2.084,16.582-4.367,24.786-6.854,8.204-2.494,16.341-5.18,24.412-8.065,8.071-2.891,16.07-5.975,23.99-9.258s15.757-6.752,23.509-10.42c7.752-3.662,15.407-7.517,22.966-11.559,7.559-4.042,15.022-8.27,22.37-12.673,7.354-4.409,14.6-8.993,21.726-13.757,7.131-4.764,14.136-9.697,21.021-14.805,6.891-5.108,13.649-10.384,20.274-15.823s13.119-11.035,19.467-16.793c6.354-5.758,12.564-11.667,18.624-17.732,6.065-6.059,11.974-12.269,17.732-18.624,5.758-6.348,11.354-12.841,16.793-19.467s10.715-13.384,15.823-20.274c5.108-6.885,10.041-13.89,14.805-21.021,4.764-7.125,9.348-14.371,13.757-21.726,4.403-7.348,8.631-14.811,12.673-22.37,4.042-7.559,7.896-15.215,11.559-22.966,3.668-7.752,7.137-15.588,10.42-23.509s6.366-15.919,9.258-23.99c2.885-8.071,5.571-16.208,8.065-24.412,2.488-8.204,4.77-16.467,6.854-24.786,2.084-8.312,3.963-16.678,5.638-25.087,1.668-8.408,3.138-16.853,4.391-25.334,1.259-8.481,2.313-16.985,3.15-25.52.843-8.535,1.47-17.082,1.891-25.641.422-8.565.632-17.136.632-25.707s-.211-17.142-.632-25.707c-.422-8.565-1.048-17.112-1.891-25.641Zm-53.556,118.629c-3.181,21.925-31.467,38.229-37.646,59.031-6.179,21.178,8.802,50.224-.188,70.091-9.178,20.049-41.015,27.734-52.816,46.102-11.988,18.55-5.621,50.788-20.043,67.281-14.422,16.486-47.201,14.805-63.687,29.233-16.48,14.24-19.479,46.849-38.023,58.843-18.356,11.994-49.259,1.123-69.302,10.307-19.667,8.996-31.844,39.546-53.01,45.726-20.79,6.185-47.389-12.929-69.302-9.742-21.354,2.999-41.58,28.857-63.869,28.857s-42.521-25.858-63.875-28.857c-21.913-3.187-48.512,15.928-69.302,9.742-21.166-6.179-33.155-36.73-53.004-45.726-20.043-9.184-50.952,1.499-69.308-10.307-18.544-11.806-21.537-44.415-38.023-58.843-16.668-14.246-49.259-12.747-63.681-29.233-14.422-16.68-8.055-48.73-20.043-67.281-11.8-18.368-43.644-26.053-52.822-46.102-8.99-19.867,5.997-48.913-.188-70.091-6.179-20.802-34.46-37.106-37.647-59.031-2.999-21.367,19.667-44.979,19.667-67.281s-22.666-45.914-19.667-67.275c2.999-21.925,31.467-38.229,37.647-59.031,6.185-21.178-8.802-50.23.188-70.091,9.178-20.055,41.021-27.734,52.822-46.102,11.988-18.556,5.621-50.788,20.043-67.281,14.422-16.492,47.201-14.805,63.681-29.233,16.486-14.24,19.479-46.849,38.023-58.843,18.356-11.994,49.265-1.129,69.308-10.307,19.667-8.996,31.837-39.546,53.004-45.732,20.79-6.179,47.389,12.935,69.302,9.749,21.354-2.999,41.586-28.863,63.875-28.863s42.515,25.865,64.057,28.863c21.913,3.187,48.512-15.928,69.302-9.749,21.166,6.185,33.155,36.736,53.01,45.732,20.043,9.178,50.946-1.499,69.302,10.307,18.544,11.806,21.543,44.415,38.023,58.843,16.668,14.24,49.265,12.741,63.687,29.233,14.422,16.68,8.049,48.724,20.037,67.281,11.8,18.368,43.644,26.047,52.822,46.102,8.99,19.861-5.991,48.913.188,70.091,6.179,20.802,34.466,37.106,37.646,59.031,2.999,21.361-19.667,44.973-19.667,67.275s22.666,45.914,19.479,67.281Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 595.717,
    y1: 850.546,
    x2: 595.717,
    y2: 836.364,
    style: {
      fill: "none",
      stroke: "#196df4",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 595.717,
    y1: 769.698,
    x2: 595.717,
    y2: 754.398,
    style: {
      fill: "none",
      stroke: "#196df4",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 710.747,
    y1: 789.338,
    x2: 710.747,
    y2: 775.155,
    style: {
      fill: "none",
      stroke: "#196df4",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 710.747,
    y1: 646.349,
    x2: 710.747,
    y2: 633.108,
    style: {
      fill: "none",
      stroke: "#196df4",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 653.232,
    y1: 824.277,
    x2: 653.232,
    y2: 812.218,
    style: {
      fill: "none",
      stroke: "#196df4",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 653.232,
    y1: 769.698,
    x2: 653.232,
    y2: 754.398,
    style: {
      fill: "none",
      stroke: "#196df4",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.976,
    y: 769.698,
    width: 42.511,
    height: 42.52,
    style: {
      fill: "#196df4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.461,
    y: 769.698,
    width: 42.511,
    height: 66.666,
    style: {
      fill: "#196df4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 689.491,
    y: 646.349,
    width: 42.511,
    height: 128.807,
    style: {
      fill: "#196df4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.152,298.986v-23.351c0-8.8,7.147-15.937,15.974-15.937h505.744c8.818,0,15.974,7.137,15.974,15.937v23.351c0,8.799-7.156,15.937-15.974,15.937h-505.744c-8.827,0-15.974-7.137-15.974-15.937Z",
    style: {
      fill: "#196df4",
      stroke: "#196df4",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m792.874,345.938h-505.744c-8.827,0-15.974,7.128-15.974,15.928v23.361c0,8.8,7.147,15.928,15.974,15.928h177.218v73.129c.046-.019.102-.037.148-.055v.342c-2.198.813-4.386,1.662-6.565,2.567-49.307,20.351-87.958,58.245-108.825,106.693-10.166,23.619-15.558,48.476-16.011,73.886-.471,26.352,4.404,52.114,14.506,76.582,10.101,24.469,24.81,46.176,43.739,64.523,18.236,17.682,39.593,31.505,63.462,41.07,23.221,9.312,47.599,14.103,72.073,14.411v-42.514c-60.11-1.023-116.279-36.03-140.068-93.677-30.895-74.846,3.813-161.105,77.543-197.347v127.994c0,4.312,7.082,7.811,15.808,7.811h20.591c8.726,0,15.808-3.499,15.808-7.811l-.194-247.604h47.091v247.604c0,4.312,7.073,7.811,15.808,7.811h20.581c8.735,0,15.808-3.499,15.808-7.811l-.185-247.604h177.412c8.818,0,15.974-7.128,15.974-15.928v-23.361c0-8.8-7.156-15.928-15.974-15.928Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTredcode);
export default __webpack_public_path__ + "static/media/Tredcode.71373f85f75d35d16070d40a8475e289.svg";
export { ForwardRef as ReactComponent };